import { z } from "zod";

/**
 * Base social URL field - optional string for social media usernames/handles
 */
export const socialUrlField = z
  .string()
  .max(255, "URL must be 255 characters or less")
  .optional();

/**
 * Instagram URL field
 */
export const instagramUrlField = socialUrlField;

/**
 * Facebook URL field
 */
export const facebookUrlField = socialUrlField;

/**
 * TikTok URL field
 */
export const tiktokUrlField = socialUrlField;

/**
 * Bluesky URL field
 */
export const blueskyUrlField = socialUrlField;

/**
 * LinkedIn URL field
 */
export const linkedinUrlField = socialUrlField;

